export enum PipType {
  Call = "call",
  Note = "note"
}
